import { render, staticRenderFns } from "./TheSuggestionButton.vue?vue&type=template&id=2d60971a&scoped=true"
import script from "./TheSuggestionButton.vue?vue&type=script&lang=ts"
export * from "./TheSuggestionButton.vue?vue&type=script&lang=ts"
import style0 from "./TheSuggestionButton.vue?vue&type=style&index=0&id=2d60971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60971a",
  null
  
)

export default component.exports